export enum JSError {
    notSupport = 'NotSupportedError: The operation is not supported.',
    notInteract = 'NotAllowedError: play() failed because the user didn\'t interact with the document first.',
}

export enum APIError {
    customError = 233,
    noVideo = 234,
    noSupportType = 235,
    noLogin = 2003,
    bookOffline = 3000,
    bookItemOffline = 3001,
    otherReceived = 5003,
    equityFrozen = 5005,
    ownershipChange = 5006,
    noChildQuestion = 5116,
    questionDeleted = 5506,
    QRCodeErrorStart = 5506,
    QRCodeErrorEnd = 5550,
    writingError = 7000,
    writingError1 = 7001,
    writingError2 = 7002,
    writingError5 = 7005,
    writingError7 = 7007,
    writingError8 = 7008,
    writingDisabled = 7009,
    polishError = 7010, //全文润色调用失败
    polishNotReturn = 7011, //全文润色结果尚未返回
    customUpgrade = 7012,
    polishEmpty = 7013, //全文润色结果为空
    writingEmptyError = 7015
}

export const isWritingError = (code: number) => [
    APIError.writingError,
    APIError.writingError1,
    APIError.writingError2,
    APIError.writingError5,
    APIError.writingError7,
    APIError.writingError8,
].includes(code)

export const isQRCodeError = (code: number) => code >= APIError.QRCodeErrorStart && code <= APIError.QRCodeErrorEnd
